import { CampoView } from "./view-campo";
import type { CampoProps } from "./types-campo";

export function Campo(props: CampoProps) {
  return <CampoView {...props} />;
}

export type * from "./types-campo";
